import React, { useState } from "react";
import SuggestionsButtonUi from "./SuggestionsButton";
import { charaterCount, getMediaType, getMediaTypeFromBlob, getAspectAndResolution, insertVariable } from "../../../Utils/Utils";
import ImageUploaderWithCrop from "./ImageUploaderWithCrop";
const StandaloneCardForm = ({ formData, setFormData, setCroppedFile, setAspectRatio,
    setRecommendedResolution, aspectRatio, recommendedResolution, route }) => {
    // const [dynamicUrl, setDynamicUrl] = useState(false);

    // assume functional component and formData state exists
    // const [formData, setFormData] = useState({ standaloneCard: { /* ... */ } });

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;

        setFormData(prev => ({
            ...prev,
            standaloneCard: {
                ...prev.standaloneCard,
                dynamic_media_url: checked
            }
        }));
    };


    const handleCardChange = (e) => {
        const { name, value } = e.target;

        let updatedData = {
            ...formData,
            standaloneCard: {
                ...formData.standaloneCard,
                [name]: value,
            },
        };

        // Clear dependent fields
        if (name === "card_orientation" && value === "horizontal") {
            updatedData.standaloneCard.media_height = "";
        }
        if (name === "card_orientation" && value === "vertical") {
            updatedData.standaloneCard.card_alignment = "";
        }

        // Get updated values after current change
        const orientation = name === "card_orientation" ? value : updatedData.standaloneCard.card_orientation;
        const height = name === "media_height" ? value : updatedData.standaloneCard.media_height;

        const { aspectRatio, resolution } = getAspectAndResolution(orientation, height);


        // Optional: store aspectRatio & resolution in state if needed
        setAspectRatio(aspectRatio); // for cropper
        setRecommendedResolution(resolution); // to show as a hint


        setFormData(updatedData);
    };


    const mediaHandler = (e) => {
        let url = e.target.value;
        let type = getMediaType(e.target.value);
        setFormData((prevData) => ({
            ...prevData, standaloneCard: {
                ...prevData.standaloneCard,
                media: {
                    file_type: type,
                    url: url
                }
            }
        }))
    }


    return (
        <div className="suggested-button">
            <div className="form-row">
                <div className="form-group drop-down-icons  col-md-6">
                    <select
                        className="form-control"
                        name="card_orientation"
                        value={formData.standaloneCard.card_orientation}
                        onChange={handleCardChange}
                    >
                        <option value="">Select Card Orientation</option>
                        <option value="horizontal">Horizontal</option>
                        <option value="vertical">Vertical</option>
                    </select>
                </div>

                {formData.standaloneCard.card_orientation === 'horizontal' ?
                    <div className="form-group drop-down-icons  col-md-6">
                        <select
                            className="form-control"
                            name="card_alignment"
                            value={formData.standaloneCard.card_alignment}
                            onChange={handleCardChange}
                        >
                            <option value="">Select Card Alignment</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </select>
                    </div>
                    :
                    <div className="form-group drop-down-icons  col-md-6">
                        <select
                            className="form-control"
                            name="media_height"
                            value={formData.standaloneCard.media_height}
                            onChange={handleCardChange}
                        >
                            <option value="">Select Media Height</option>
                            <option value="short">Short Height</option>
                            <option value="medium">Medium Height</option>
                        </select>
                    </div>
                }

            </div>
            {/* <div className="form-row">
                <div className="form-group drop-down-icons  col-md-12">
                    <select
                        className="form-control"
                        name="file_type"
                        disabled
                        value={formData.standaloneCard.file_type}
                        onChange={handleCardChange}
                    >
                        <option value="Public">Public Image / Video  </option>
                        <option value="Upload">Upload Image / Video </option>
                    </select>
                </div>
            </div> */}
            <div className="form-row">
                <div className="form-group col-md-12">
                    {/* <input
                        type="text"
                        className="form-control"
                        name="media"
                        value={formData.standaloneCard.media.url}
                        onChange={(e) => mediaHandler(e)}
                        placeholder="Enter Public Image/Video URL"
                    /> */}
                    {(aspectRatio || (Array.isArray(aspectRatio) && aspectRatio.length > 0))
                        ? (
                            <ImageUploaderWithCrop
                                onImageCropped={(previewUrl, blob, file = null) => {
                                    // Save preview URL to formData
                                    let type = getMediaTypeFromBlob(blob);
                                    setFormData((prev) => ({
                                        ...prev,
                                        standaloneCard: {
                                            ...prev.standaloneCard,
                                            media: {
                                                ...prev.standaloneCard.media,
                                                file_type: type,
                                                url: previewUrl, // for preview purposes
                                                ...(file && { file }),
                                            },
                                        },
                                    }));

                                    // Save blob for submission
                                    setCroppedFile(blob); // you'll need this for API later
                                }}
                                aspectRatio={aspectRatio}
                                recommendedResolution={recommendedResolution}
                                currentMedia={formData.standaloneCard.media}
                            />)
                        : (
                            <div className="text-danger mb-2">
                                Please select a valid Card Orientation and Media Height to enable image upload.
                            </div>
                        )}
                </div>
            </div>

            {(formData.standaloneCard.card_orientation && route === 46) &&
                <div>
                    <input
                        type="checkbox"
                        name="dynamic_media_url"
                        checked={!!formData.standaloneCard?.dynamic_media_url} // safe access and boolean
                        onChange={handleCheckboxChange}
                        style={{ cursor: "pointer" }}
                    />

                    <label className="ms-2 ml-2"><b>If you want to make the URL dynamic, click on the checkbox. The variable parameter will be <span>{`[fileUrl 1]`}</span>.</b></label>

                    {/* <p>Checkbox is: {checked ? "Checked" : "Unchecked"}</p> */}
                </div>}

            <div className="form-row">
                <div className="form-group col-md-12">
                    <input
                        type="text"
                        className="form-control"
                        name="card_title"
                        id="card_title"
                        value={formData.standaloneCard.card_title}
                        onChange={handleCardChange}
                        placeholder="Enter Card Title"
                        maxLength={200}
                    />
                    <div className="d-flex mt-2 justify-content-between">
                        {charaterCount(formData.standaloneCard?.card_title, formData.templateType)}
                        {!formData.standaloneCard.card_title.includes('[title1]') &&
                            <span className="badge badge-primary" onClick={() => insertVariable(document.getElementById('card_title'), formData, setFormData, 'title')}>Add Varibale</span>
                        }
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <textarea
                        className="form-control"
                        name="card_description"
                        id="card_description"
                        rows={5}
                        value={formData.standaloneCard.card_description}
                        onChange={handleCardChange}
                        placeholder="Enter Card Description"
                        maxLength={2000}
                    />
                    <div className="d-flex mt-2 justify-content-between">
                        {charaterCount(formData.standaloneCard?.card_description, "standalone")}
                        <span className="badge badge-primary" onClick={() => insertVariable(document.getElementById('card_description'), formData, setFormData,)}>Add Varibale</span>
                    </div>
                </div>
            </div>
            <SuggestionsButtonUi formData={formData} setFormData={setFormData} />
        </div>
    );
};

export default StandaloneCardForm;
